import type { BusinessProfile, RsuiteSortType } from '@@partner:types:app'

import React from 'react'
import {
  normalizePhoneNumber,
  formatDate,
  formatPhone
} from '@@partner:helpers/util'

import { Link, generatePath } from 'react-router-dom'
import { Button, ButtonGroup, Table, Tag } from 'rsuite'
import LegacyPhoneIcon from '@rsuite/icons/legacy/Phone'
import BusinessProfileStatusLabel from '../common/BusinessProfileStatusLabel'
import AppLoader from '@components/common/AppLoader'

import {
  ROUTE_EDIT_BUSINESS_PROFILE,
  ROUTE_CUSTOMERS_VIEW_CUSTOMER
} from '@@partner:config/routes'

const Column = Table.Column
const HeaderCell = Table.HeaderCell
const Cell = Table.Cell

export interface BusinessProfilesTableProps {
  brandSlug: string
  businessProfiles: BusinessProfile[]
  loading?: boolean
  sortColumn: string
  sortType: RsuiteSortType | undefined
  onSortColumn: (
    sortColumn: string,
    sortType: RsuiteSortType | undefined
  ) => void
}

export default function BusinessProfilesTable ({
  brandSlug,
  businessProfiles = [],
  loading = false,
  sortColumn,
  sortType,
  onSortColumn
}: BusinessProfilesTableProps) {
  return (
    <Table
      data={businessProfiles}
      onSortColumn={onSortColumn}
      sortColumn={sortColumn}
      sortType={sortType}
      autoHeight
      wordWrap
      loading={loading}
      renderLoading={() =>
        loading ? <AppLoader.Inner content="Загрузка таблицы" /> : null
      }
      affixHeader
      rowHeight={120}
      className="BusinessProfilesTable"
    >
      <Column sortable flexGrow={1} verticalAlign="middle">
        <HeaderCell>ИД</HeaderCell>
        <Cell dataKey="id"></Cell>
      </Column>
      <Column sortable verticalAlign="middle">
        <HeaderCell>ИД ТУС</HeaderCell>
        <Cell dataKey="xid"></Cell>
      </Column>
      <Column verticalAlign="middle">
        <HeaderCell>БИН/ИИН</HeaderCell>
        <Cell dataKey="tin"></Cell>
      </Column>
      <Column verticalAlign="middle">
        <HeaderCell>Тип</HeaderCell>
        <Cell dataKey="type"></Cell>
      </Column>
      <Column flexGrow={3} verticalAlign="middle">
        <HeaderCell>Название</HeaderCell>
        <Cell dataKey="name"></Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Статус</HeaderCell>
        <Cell dataKey="status">
          {(customer: BusinessProfile) => (
            <>
              <BusinessProfileStatusLabel status={customer.status} />
            </>
          )}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Создан</HeaderCell>
        <Cell dataKey="created_at">
          {(customer: BusinessProfile) => (
            <Tag color="blue">{formatDate(new Date(customer.created_at))}</Tag>
          )}
        </Cell>
      </Column>
      <Column sortable flexGrow={3} verticalAlign="middle">
        <HeaderCell>Обновлен</HeaderCell>
        <Cell dataKey="updated_at">
          {(customer: BusinessProfile) => (
            <Tag color="blue">{formatDate(new Date(customer.updated_at))}</Tag>
          )}
        </Cell>
      </Column>

      <Column flexGrow={4} fixed="right" verticalAlign="middle">
        <HeaderCell>Управление</HeaderCell>
        <Cell>
          {(profile: BusinessProfile) => (
            <ButtonGroup>
              <Button
                color="cyan"
                appearance="primary"
                as={Link}
                to={generatePath(ROUTE_EDIT_BUSINESS_PROFILE, {
                  brandSlug,
                  profileId: profile.id
                })}
                size="xs"
              >
                Изменить
              </Button>
            </ButtonGroup>
          )}
        </Cell>
      </Column>
    </Table>
  )
}
